module.exports = __webpack_public_path__ + "media/images/application/template/logoslider/logo-dhl-f6e1ec013c9e035b1d413356638cdfca.png";